export default __webpack_public_path__ + "715a746cc29ad8bcde9b6e1346cc821b.png";